module.exports = __webpack_public_path__ + "static/media/cod-bo.b3707664.jpg";